export const publicSaleIn: number = 1681214400000; //timestamp in milliseconds